import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconForward$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconForward extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4a6e1f0f70b53e5e26b4a9e4d37335c0cd4eb847', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '69c3f2eeb56ef7ed3ca9e2b73da28d4aa67962d3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'af37866e6fa79a055b3df29d748f843473485511', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 11.518 5.72 16.44A.5.5 0 0 1 5 16V6a.49.49 0 0 1 .72-.46L12 10.462V6a.49.49 0 0 1 .72-.46l6.38 5a.5.5 0 0 1 0 .9l-6.38 5A.5.5 0 0 1 12 16z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-forward", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-forward"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-forward":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconForward$1);
            }
            break;
    } });
}

const CosmosIconForward = CosmosIconForward$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconForward, defineCustomElement };
